var exports = {
  "AS": "x1cb7f6e3--9cd99c--item",
  "ly": "x1cb7f6e3--9cd99c--right-icon",
  "QP": "x1cb7f6e3--9cd99c--item-selected",
  "_1": "x1cb7f6e3--9cd99c--left-icon",
  "AH": "x1cb7f6e3--9cd99c--text-area",
  "DD": "x1cb7f6e3--9cd99c--title",
  "VA": "x1cb7f6e3--9cd99c--subtitle",
};

module.exports = exports;
